import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export const FEATURES = [
  ["bookings", "Bookings", "On-site booking form and the Bookings tab"],
  ["calendar", "Calendar", "Staff calendar view in the admin"],
  ["my-calendar", "My calendar", "Team members' own calendar view"],
  ["team", "Team & schedules", "Team list, work hours and the staff picker when booking"],
  ["payments", "Service sales", "Booking payments under Revenue"],
  ["shop", "Shop", "Shop page and the Shop items tab"],
  ["shop-sales", "Shop sales — online payment", "On: customers can pay online (PayPal / card) or choose pay at pickup. Off: customers can still order from the shop, but only reserve and pay in store at pickup"],
  ["customers", "Customers", "Customer list and profiles"],
  ["messages", "Messages & contact form", "“Send us a message” form and the Messages tab"],
  ["work", "Our Work", "Our Work photos on the homepage, the Our Work page and its admin tab"],
  ["reviews", "Reviews", "Reviews on the Our Work page and the Reviews tab"],
  ["popups", "Pop-ups", "Sign-up and promotion pop-ups on the website"],
  ["music", "Background music", "Music player on the website and the Music tab"],
  ["automations", "Automations", "Birthday, reminder and thank-you emails"],
  ["inspiration", "Inspiration pages", "Gallery tiles that open treatment inspiration pages"],
];
export const FEATURE_LABEL = Object.fromEntries(FEATURES.map(([k, l]) => [k, l]));

export const useFeatures = () =>
  useQuery({ queryKey: ["features"], queryFn: () => api.get("/features").then((r) => r.data), staleTime: 60_000 }).data;

export const useOn = (key) => useFeatures()?.[key] !== false;

export const On = ({ k, children }) => (useOn(k) ? children : null);

export const Gate = ({ k, children }) => {
  const f = useFeatures();
  if (f && f[k] === false) return <Navigate to="/" replace />;
  return children;
};
